import * as React from 'react'
import Box from '@mui/material/Box'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import { LightTooltip } from '@sales-center/components'
import { useData, useHandlers } from './hooks'
import { IconButtonStyled } from './IconButton.styled'
import { BadgeStyled } from './Badge.styled'
import { useTheme } from '@mui/material/styles'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function ActivitiesButton(props: Props) {
  const { entityId, entityType } = props
  const { handleClick } = useHandlers()
  const { badgeContent, badgeColor, showBadge } = useData()
  const theme = useTheme()
  const preparedBadgeContent =
    badgeContent === '' ? (
      <Box
        width="3px"
        height="3px"
        margin="auto"
        bgcolor={theme.palette.common.white}
        borderRadius="50%"
      ></Box>
    ) : (
      badgeContent
    )

  return (
    <BadgeStyled
      color={badgeColor}
      badgeContent={preparedBadgeContent}
      overlap="circular"
      max={9}
      invisible={!showBadge}
    >
      <LightTooltip title="Activities">
        <IconButtonStyled
          size="large"
          aria-describedby="popover"
          onClick={handleClick}
          data-test-id={`activities-button-${entityType.toLowerCase()}-${entityId}`}
        >
          {/* This is a 29x29 layout box; the Material glyph only fills 20 of
              its 24 viewBox units, so the painted icon is ~22x24 — matching
              the 20x24.5 icon it replaces. The box size does not affect
              layout here: the button is a fixed 46x46. */}
          <AssignmentOutlined color="primary" sx={{ fontSize: 29 }} />
        </IconButtonStyled>
      </LightTooltip>
    </BadgeStyled>
  )
}
